import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, getHomePath } from '../context/AuthContext';

export default function ProtectedRoute({ children, adminOnly = false, providerOnly = false, blockCustomer = false }) {
  const { user, role, roleLoading, tenantIds } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly || providerOnly || blockCustomer) {
    if (roleLoading) return null;
    // provider is treated as a superset of admin — NordComply can still open
    // every admin-portal screen to look at any MSP's data.
    if (adminOnly && role !== 'admin' && role !== 'provider') {
      return <Navigate to={getHomePath(role, tenantIds)} replace />;
    }
    if (providerOnly && role !== 'provider') {
      return <Navigate to={getHomePath(role, tenantIds)} replace />;
    }
    if (blockCustomer && role === 'customer') {
      return <Navigate to={getHomePath(role, tenantIds)} replace />;
    }
  }

  return children;
}
